import Styled from 'styled-components'

export default Styled.i.attrs(props => ({
  children: props.liga,
  className: 'material-icons'
}))``

// class Icon extends Component {
//   render() {
//     return (
//       <i className="material-icons">{this.props.liga}</i>
//     )
//   }
// }

// export default Icon



// WEBPACK FOOTER //
// ./src/components/Icon/index.js